import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { env } from './environment/env'

if (env.NEW_RELIC_ENABLED === true && env.NEW_RELIC_APPLICATION_ID) {
  // Populate using values in copy-paste JavaScript snippet.

  const newRelicApplicationId = env.NEW_RELIC_APPLICATION_ID
  const options = {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
    }, // NREUM.init
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: 'NRBR-f281a9d683a539fcd84',
      applicationID: newRelicApplicationId,
      sa: 1,
    }, // NREUM.info
    loader_config: {
      accountID: '815571',
      trustKey: '815571',
      agentID: newRelicApplicationId,
      licenseKey: 'NRBR-f281a9d683a539fcd84',
      applicationID: newRelicApplicationId,
    }, // NREUM.loader_config
  }

  // The agent loader code executes immediately on instantiation.
  // eslint-disable-next-line no-new
  new BrowserAgent(options)
}
